import { Box } from '@mui/material';
import imgNone from '../images/LCs.png';
import imgLC1 from '../images/LC1.png';
import imgLC1LC2 from '../images/LC1LC2.png';
import imgLC1LC2LC3 from '../images/LC1LC2LC3.png';

interface TruckVisualizationProps {
  selectedCompartments: { lc1: boolean; lc2: boolean; lc3: boolean };
  onToggle: (compartment: 'lc1' | 'lc2' | 'lc3') => void;
}

function resolveImage(s: { lc1: boolean; lc2: boolean; lc3: boolean }): string {
  if (s.lc1 && s.lc2 && s.lc3) return imgLC1LC2LC3;
  if (s.lc1 && s.lc2) return imgLC1LC2;
  if (s.lc1) return imgLC1;
  return imgNone;
}

// Clickable zones (left-to-right in image: LC3, LC2, LC1+cab)
const ZONES: {
  key: 'lc3' | 'lc2' | 'lc1';
  left: string;
  width: string;
  disabled: boolean;
}[] = [
  { key: 'lc3', left: '0%', width: '33%', disabled: true },
  { key: 'lc2', left: '33%', width: '34%', disabled: false },
  { key: 'lc1', left: '67%', width: '33%', disabled: false },
];

export function TruckVisualization({
  selectedCompartments,
  onToggle,
}: TruckVisualizationProps) {
  return (
    <Box sx={{ position: 'relative', display: 'inline-block', lineHeight: 0 }}>
      <Box
        component="img"
        src={resolveImage(selectedCompartments)}
        alt="truck LC visualization"
        sx={{
          height: 72,
          display: 'block',
          userSelect: 'none',
          transition: 'content 0.1s',
        }}
      />

      {/* Invisible click zones per segment */}
      {ZONES.map(({ key, left, width, disabled }) => (
        <Box
          key={key}
          onClick={() => !disabled && onToggle(key)}
          title={disabled ? undefined : key.toUpperCase()}
          sx={{
            position: 'absolute',
            top: 0,
            left,
            width,
            height: '100%',
            cursor: disabled ? 'not-allowed' : 'pointer',
          }}
        />
      ))}
    </Box>
  );
}
